import TextField from "@material-ui/core/TextField";
import {
  Box,
  IconButton,
} from "@material-ui/core";
import CachedIcon from '@material-ui/icons/Cached';
import DownloadIcon from '@mui/icons-material/Download';
import { Stack } from "@mui/material";
import { api_call, curl_post, getToken } from "../helpers/untils";
import { API_BASE_URL } from "../config/constant";

const DeviceApiKeyBox = (props) => {
  const { item, setItem } = props;

  const onClickGenerateApiKey = async () => {
    if (window.confirm("Are you sure you want to rotate apiKey?")) {
      const url = `/api/devices/update-api-key`
      let response = await api_call(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deviceId: item.id }),
      });
      if (response.ok) {
        const apiResObj = await response.json();
        const apiKey = apiResObj['apiKey'];
        setItem({ ...item, apiKey: apiKey });
      } else {
        window.alert(`Failed to generate api key`)
      }
    }
  }

  const onClickDownloadExcel = () => {
    const token = getToken()
    const deviceId = item?.id
    const payload = {
      deviceId: deviceId,
    }
    console.log(`onClickDownloadExcel payload:::`, payload)
    const urlExport = API_BASE_URL + "/api/devices/download-user-cars";
    const exportFileName = `my_devices.xlsx`
    curl_post(urlExport, { ...payload, exportFileName }, 'post', "", true, token); //window.location.href = exportUrl
  }

  return (
    <>
      <Box style={{ width: '100%', marginTop: '24px' }}>
        <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
          <TextField
            margin="normal"
            value={item.apiKey || ""}
            label="Api-Key"
            variant="filled"
            disabled={true}
            fullWidth
          />
          <IconButton
            size={`medium`}
            type="button"
            title="Generate"
            onClick={() => onClickGenerateApiKey()}
          >
            <CachedIcon />
          </IconButton>
          <IconButton
            size={`medium`}
            type="button"
            title="Export Excel"
            onClick={() => onClickDownloadExcel()}>
            <DownloadIcon />
          </IconButton>
        </Stack>
      </Box>
    </>
  );
};

export default DeviceApiKeyBox;
